import React from 'react';

import { FormikCheckbox } from '~commonInfra/components/FormikCheckbox';

import { Messages } from '../../../../../codegen/Localize';
import { FeatureFlags } from '../../../../../ts/FeatureFlags';
import { SettingsSection } from '../../../../components/common/SettingsSection';
import { groupNameMessage } from '../../../../styles/CommonStyles';
import { componentRegistryEntry } from '../../SettingsComponentRegistryFunctions';
import { SiteSettingsForSiteAdminProps } from '../../site-settings/ReactSiteSettingsForSiteAdmin';
import { forceUncheckedIfUserVisibilityLimited, useUserVisibilityLimited } from '../user-visibility/UserVisibilitySection';

export const SHARING_ENABLED_FIELD = 'settings.siteNamedSharingSettings.namedSharingEnabled';

export type SharingSectionProps = SiteSettingsForSiteAdminProps<'siteNamedSharingSettings' | 'userVisibility'>;

export function SharingSection() {
  const isUserVisibilityLimited = useUserVisibilityLimited();
  const sharingCheckboxLabel = FeatureFlags.userNotificationSettingsEnabled &&
    FeatureFlags.sharingInAppNotificationsEnabled ?
    Messages.namedSharingCheckboxLabel() :
    Messages.namedSharingCheckboxLabelLegacy();

  const sharingDetails = FeatureFlags.userNotificationSettingsEnabled &&
    FeatureFlags.sharingInAppNotificationsEnabled ?
    Messages.namedSharingDetails() :
    Messages.namedSharingDetailsLegacy();

  return FeatureFlags.namedSharingEnabled
    ? (
      <SettingsSection title={renderTitle(isUserVisibilityLimited)}
                       testId={'sharing-setting-section'}
                       description={sharingDetails}
                       disabled={isUserVisibilityLimited}>
        <FormikCheckbox
                        name={SHARING_ENABLED_FIELD}
                        label={sharingCheckboxLabel}
                        testId={'named-sharing'}
                        disabled={isUserVisibilityLimited}
                        {...forceUncheckedIfUserVisibilityLimited(isUserVisibilityLimited)}>
        </FormikCheckbox>
      </SettingsSection>
    )
    : null;
}

function renderTitle(userVisibilityLimited: boolean) {
  return <>
    <span>{Messages.namedSharingTitle()}</span>
    {userVisibilityLimited &&
    <span className={groupNameMessage} data-tb-test-id={'named-sharing-uservisibility-warning'}>
      {Messages.userVisibilityWarning()}
    </span>}
  </>;
}

export const SharingSectionSpecs = componentRegistryEntry({
  name: 'SharingSection',
  component: SharingSection
});
